import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import axios from "axios";
import { fileNotFound, maestroIcon, mastercardIcon, paypalIcon, visaIcon } from "../../assets/images/icons";
import { RemoveOrder } from "../main_compos/ShoppingCart";
import Navigation from "../header_footer/Navgation";
import Footer from "../header_footer/Footer";
import { cities_and_regions, regions } from "../../assets/content/cities_and_regions";
import Notify from "../../utils/useNotify";
import { useNavigate } from "react-router";
import RegisterCheckout from "./RegisterCheckout";
import { useRefresh } from "../../utils/RefreshProvider";
import { CashOnDeliveryPayment, CreditCardPayment, PaypalPayment } from "./PaymentMethods";

const PaymentIcons = () => (
  <div className="flex flex-wrap gap-2 justify-center">
    {[maestroIcon, mastercardIcon, visaIcon, paypalIcon].map((icon, index) => (
      <img loading="lazy" key={index} src={icon} className="w-auto h-6" alt={`payment-icon-${index}`} />
    ))}
  </div>
);

const AddressForm = ({ email, setEmail, phone, setPhone, zip_code, setZip_code, selectedRegion, setSelectedRegion,
  cities, setCities, city, setCity, address_line1, setAddress_line1, address_line2, setAddress_line2, token,
  session_id, fullname, setFullname }) => {
  const { t } = useTranslation();

  const handleRegionChange = (e) => {
    const regionId = e.target.value;
    setSelectedRegion(regionId);
    const filteredCities = cities_and_regions.filter(city => city.region.id === regionId);
    setCities(filteredCities);
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div className="max-sm:col-span-2">
        <label className="mb-2 block text-sm font-medium text-gray-900">{t("fullname")} <span className="text-red-500">*</span></label>
        <input type="text" name="full-name" value={fullname} onChange={(e) => setFullname(e.target.value)}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          placeholder={t("ur-fullname")} required />
      </div>
      <div className="max-sm:col-span-2">
        <div className="flex justify-between items-center gap-2">
          <label className="mb-2 block text-sm font-medium text-gray-900">{t("email")} <span className="text-red-500">*</span></label>
          {!token ? <RegisterCheckout emailProp={email} sessionIdProp={session_id} /> : <div />}
        </div>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          placeholder={t("email")} required />
      </div>
      <div className="max-sm:col-span-2">
        <label className="mb-2 block text-sm font-medium text-gray-900">{t("phone")} <span className="text-red-500">*</span></label>
        <PhoneInput name="phone" className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:outline-none"
          placeholder={t("ur-phone")} value={phone} onChange={setPhone} />
      </div>
      <div className="max-sm:col-span-2">
        <label className="mb-2 block text-sm font-medium text-gray-900">{t("postcode")} <span className="text-red-500">*</span></label>
        <input type="number" value={zip_code} onChange={(e) => setZip_code(e.target.value)}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          placeholder={t("ur-postcode")} required />
      </div>
      <div className="max-sm:col-span-2">
        <div className="mb-2 flex items-center gap-2">
          <label className="block text-sm font-medium text-gray-900">{t("region")} <span className="text-red-500">*</span></label>
        </div>
        <select className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          value={selectedRegion} onChange={handleRegionChange}>
          <option value="">{t("select-region")}</option>
          {regions.map((region) => (
            <option key={region.id} value={region.id}>{region.region}</option>
          ))}
        </select>
      </div>
      <div className="max-sm:col-span-2">
        <div className="mb-2 flex items-center gap-2">
          <label className="block text-sm font-medium text-gray-900">{t("city")} <span className="text-red-500">*</span></label>
        </div>
        <select className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          value={city} onChange={(e) => setCity(e.target.value)} disabled={!selectedRegion}>
          <option value="">{t("select-city")}</option>
          {cities.map((city) => (
            <option key={city.id} value={city.name}>{city.name}</option>
          ))}
        </select>
      </div>
      <div className="col-span-2">
        <label className="mb-2 block text-sm font-medium text-gray-900">{t("address-line") + " 1"} <span className="text-red-500">*</span></label>
        <input type="text" name="address-line-1" value={address_line1} onChange={(e) => setAddress_line1(e.target.value)}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          placeholder={t("ur-address-line") + " 1"} required />
      </div>
      <div className="col-span-2">
        <label className="mb-2 block text-sm font-medium text-gray-900">{t("address-line") + " 2"}</label>
        <textarea name="address-line-2" value={address_line2} onChange={(e) => setAddress_line2(e.target.value)}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-primary-500 focus:ring-primary-500"
          placeholder={t("ur-address-line") + " 2"}></textarea>
      </div>
    </div>
  );
};

const OrderSummary = ({ orders, localimg, calculateTotalAmount }) => {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="text-xl font-semibold text-gray-900">{t("all-purchases")}</h3>
      <ul className='flex flex-col gap-2 mt-4'>
        {orders.map((item, index) => (
          <li key={index} className="p-2 flex items-center gap-1 border rounded-md bg-white shadow-sm">
            <img loading="lazy" src={item.imgs ? localimg + item.imgs[0] : fileNotFound} className="w-[12%] rounded-md mr-1" alt="product" />
            <div className="flex-1">
              <div className='flex justify-between items-start gap-1'>
                <p className='text-base text-black mr-1 font-semibold leading-none'>{item.product_name[i18next.language]}</p>
                <RemoveOrder productId={item.product_id} sizeId={item.size_id} btn />
              </div>
              <div className='flex justify-between gap-1 items-center mt-1'>
                <p className="text-xs leading-none">{t("size")} {item.size_name}</p>
                <p className='text-sm mt-1 flex flex-wrap font-semibold leading-3'>
                  <span className='text-gray-500 mr-1 font-normal'>{item.total_quantity} x</span> {item.total_amount} MAD
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <div className="flow-root mt-4">
        <div className="-my-3 divide-y divide-gray-200">
          <dl className="flex items-center justify-between gap-4 py-3">
            <dt className="text-base font-bold text-gray-900">{t("subtotal")}</dt>
            <dd className="text-base font-bold text-gray-900">{calculateTotalAmount()} <span className='text-xs leading-none'>MAD</span></dd>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default function Checkout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { refreshKey } = useRefresh();
  const token = localStorage.getItem('token');
  const session_id = localStorage.getItem('session_id');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;

  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [fullname, setFullname] = useState('');
  const [zip_code, setZip_code] = useState('');
  const [city, setCity] = useState('');
  const [address_line1, setAddress_line1] = useState('');
  const [address_line2, setAddress_line2] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [cities, setCities] = useState([]);

  const [payMethod, setPayMethod] = useState('credit-card');
  const [nameCard, setNameCard] = useState('');
  const [cardnumber, setCardnumber] = useState('');
  const [exp_date, setExp_date] = useState('');
  const [cvv, setCvv] = useState('');

  const fetchOrders = async () => {
    try {
      const res = await axios.post(localhost + "shopping-cart", { session_id }, { headers: { Authorization: `Bearer ${token}` } });
      const data = res.data;
      const updatedData = data.map(item => ({ ...item, product_name: JSON.parse(item.product_name), imgs: JSON.parse(item.imgs) }));
      setOrders(updatedData);

      const getData = await axios.post(localhost + "get-address", { session_id }, { headers: { Authorization: `Bearer ${token}` } });
      const userData = getData.data;
      console.log(userData);
      if (userData) {
        setEmail(userData.email || "");
        setPhone(userData.phone || "");
        setFullname(userData.full_name || "");

        if (userData.address) {
          setZip_code(userData.address.zip_code || "");
          const regionId = getRegionByName(userData.address.region || "");
          setSelectedRegion(regionId);

          const filteredCities = cities_and_regions.filter(city => city.region.id === regionId);
          setCities(filteredCities);

          setCity(userData.address.city || "");
          setAddress_line1(userData.address.address_line1 || "");
          setAddress_line2(userData.address.address_line2 || "");
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [refreshKey]);

  const calculateTotalAmount = () => {
    return orders.reduce((sum, order) => sum + parseFloat(order.total_amount), 0).toFixed(2);
  };

  const getRegion = (id) => {
    const reg = regions.find((item) => item.id === id);
    return reg.region;
  };

  const getRegionByName = (name) => {
    const reg = regions.find((item) => item.region === name);
    return reg.id;
  };

  const handleSubmit = async (e) => {
    setBtnLoading(true);
    e.preventDefault();

    let data = null;

    if (payMethod === "credit-card") {
      const newcardnumber = cardnumber.slice(-4);
      data = {
        session_id,
        email,
        phone,
        zip_code,
        region: getRegion(selectedRegion),
        city,
        address_line1,
        address_line2,
        amount: calculateTotalAmount(),
        method: payMethod,
        fullname,
        "name-on-card": nameCard,
        cardnumber: newcardnumber,
        exp_date,
        cvv,
      };
    } else {
      data = {
        session_id,
        email,
        phone,
        zip_code,
        region: getRegion(selectedRegion),
        city,
        address_line1,
        address_line2,
        amount: calculateTotalAmount(),
        method: payMethod,
        fullname,
      };
    };

    try {
      const res = await axios.post(`${localhost}payment`, data, { headers: { Authorization: `Bearer ${token}` } });
      Notify("success", t("process-payment-success"));
      console.log(res.data.adjusted_orders);
      setTimeout(() => navigate(token ? "/account/purchases" : "/"), 1000);
    } catch (err) {
      console.error(err);
      Notify("error", t("process-payment-error"));
    } finally {
      setTimeout(() => setBtnLoading(false), 1200);
    }
  };

  return (
    <section className="bg-white text-black">
      <Navigation />
      <form onSubmit={handleSubmit} className="container mx-auto pt-2 pb-16 px-4">
        <div className="mt-6 lg:flex lg:items-start lg:gap-12 xl:gap-16">
          <div className="min-w-0 flex-1 space-y-8">
            <div className="space-y-4">
              <h2 className="text-xl font-semibold text-gray-900">{t("payment-details")}</h2>
              {loading ? (
                <div className="min-h-[35vh] flex items-center justify-center">
                  <div className="loading-spinner" />
                </div>
              ) : (
                <AddressForm
                  email={email}
                  setEmail={setEmail}
                  phone={phone}
                  setPhone={setPhone}
                  zip_code={zip_code}
                  setZip_code={setZip_code}
                  selectedRegion={selectedRegion}
                  setSelectedRegion={setSelectedRegion}
                  cities={cities}
                  setCities={setCities}
                  city={city}
                  setCity={setCity}
                  address_line1={address_line1}
                  setAddress_line1={setAddress_line1}
                  address_line2={address_line2}
                  setAddress_line2={setAddress_line2}
                  token={token}
                  session_id={session_id}
                  fullname={fullname}
                  setFullname={setFullname}
                />
              )}
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-900">{t("payment")}</h3>
              <div className="bg-gray-50 p-4 rounded-lg border shadow">
                {loading ? (
                  <div className="min-h-[30vh] flex items-center justify-center">
                    <div className="loading-spinner" />
                  </div>
                ) : (
                  <div>
                    <div className="mb-4">
                      <label className='flex items-center gap-2 cursor-pointer text-black font-semibold'>
                        <input type="radio" value="credit-card" checked={payMethod === 'credit-card'}
                          onChange={() => setPayMethod('credit-card')} className='size-4 transition-all focus:outline-none' name="payment-method" />
                        {t("credit-card")}
                      </label>
                    </div>
                    {payMethod === "credit-card" && (
                      <CreditCardPayment
                        nameCard={nameCard}
                        setNameCard={setNameCard}
                        cardnumber={cardnumber}
                        setCardnumber={setCardnumber}
                        exp_date={exp_date}
                        setExp_date={setExp_date}
                        cvv={cvv}
                        setCvv={setCvv}
                        btnLoading={btnLoading}
                        orders={orders}
                        t={t}
                      />
                    )}

                    <div className="mt-4">
                      <label className='flex items-center gap-2 cursor-pointer text-black font-semibold'>
                        <input type="radio" value="paypal" checked={payMethod === 'paypal'}
                          onChange={() => setPayMethod('paypal')} className='size-4 transition-all focus:outline-none' name="payment-method" />
                        Paypal
                      </label>
                    </div>
                    {payMethod === "paypal" && <PaypalPayment t={t} />}

                    <div className="mt-4">
                      <label className='flex items-center gap-2 cursor-pointer text-black font-semibold'>
                        <input type="radio" value="cash-on-delivery" checked={payMethod === "cash-on-delivery"}
                          onChange={() => setPayMethod("cash-on-delivery")} className='size-4 transition-all focus:outline-none' name="payment-method" />
                        Cash on delivery
                      </label>
                    </div>
                    {payMethod === "cash-on-delivery" && <CashOnDeliveryPayment btnLoading={btnLoading} orders={orders} t={t} />}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mt-6 w-full space-y-6 sm:mt-8 lg:mt-0 lg:max-w-sm xl:max-w-lg">
            {loading ? (
              <div className="min-h-[25vh] flex items-center justify-center">
                <div className="loading-spinner" />
              </div>
            ) : (
              <>
                <OrderSummary
                  orders={orders}
                  localimg={localimg}
                  calculateTotalAmount={calculateTotalAmount}
                />
                <PaymentIcons />
              </>
            )}
          </div>
        </div>
      </form>
      <Footer />
    </section>
  );
}